import { SentryTraced } from "@sentry/nestjs"
import open from "open"
import pkceChallenge from "pkce-challenge"
import { z } from "zod"

import { AuthService, VaultService } from "../services/index.js"
import { commonFlags, getTargetEnv, SentryCommand } from "../types/index.js"

export default class Login extends SentryCommand<object> {
  static override args = {}
  static override description = "Login to the Supernova"
  static override examples = ["<%= config.bin %> <%= command.id %>"]
  static override flags = commonFlags
  private readonly authService: AuthService = new AuthService()
  private readonly vaultService: VaultService = new VaultService()

  get commandId(): string {
    return Login.id
  }

  get configSchema() {
    return z.object({})
  }

  @SentryTraced()
  public async run(): Promise<void> {
    const env = getTargetEnv()

    const { code_challenge: codeChallenge, code_verifier: codeVerifier } = await pkceChallenge()

    this.log("\n🔐 Authentication Process\n".green)
    this.log("1. Opening browser for authentication...")
    const { authorizeUrl, readKey } = await this.authService.getAuthUrlFromServer(env, codeChallenge)
    await this.openBrowser(authorizeUrl)
    this.log("2. Waiting for authentication to complete...")
    const tokens = await this.authService.getTokensFromServer(env, codeVerifier, readKey)
    if (tokens) {
      this.log("3. Login successful!")
      this.log("4. Storing tokens...")
      await this.vaultService.storeTokensToVault(tokens, env)
      this.log("5. You are now logged in".green)
    } else {
      this.log("3. Login timed out".red)
    }
  }

  @SentryTraced()
  private async openBrowser(url: string) {
    try {
      await open(url)
    } catch {
      this.log("Unable to open browser automatically - please visit the URL manually")
      this.log(`\u001B[4m\u001B[34m${url}\u001B[0m\n`)
    }
  }
}
